module.exports = __webpack_public_path__ + "img/link-related.5bb9253d.svg";